export default {
      id: "icon-balkonlu-oda-usage",
      viewBox: "0 0 507.4 507.4",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-balkonlu-oda",
      toString: function () {
        return this.url;
      }
    }